import { Inviter, Session, SessionState } from "sip.js";
import { SessionDescriptionHandler as SessionDescriptionHandlerWeb } from "sip.js/lib/platform/web";
import { setupRemoteMedia } from './setupRemoteMedia';
import { Store } from "vuex";
import { stopSendingVideo } from ".";
import { salesforceUpdateCallConnected, salesforceLogACall} from './salesforceHelper.js';

var beepA4 = require('browser-beep')({ frequency: 440 })
var beepE5 = require('browser-beep')({ frequency: 660 })

export const createSessionListener = (session: Session, store: Store<any>) => (state:any) => {

    switch (state) {
        case SessionState.Initial:
            break;

        case SessionState.Establishing:
            beepA4(2);
            break;

        case SessionState.Established:
            beepA4(1)
            beepE5(1)
            console.log('session established');
            console.log(session)
            setupRemoteMedia(session, store); // idempotent
            // TODO: Remove when we have replaced SDH and MSH
            // if (session instanceof Inviter) stopSendingVideo(session);
	    salesforceUpdateCallConnected(session);
            break;

        case SessionState.Terminating:
            break;

        case SessionState.Terminated:
            beepA4(3); // Call ended
            cleanupMedia(session);
            sessionOver(session, store);
	    salesforceLogACall(session);

            break;
    }

    store.commit('sip/forceSessionsUpdate');
}

const sessionOver = (session: Session, store: Store<any>) => {
    setTimeout(
        () => store.commit('sip/delSession', session),
        2500
    );
}

function cleanupMedia(session: Session) {
    const { mediaElement } = session as any;
    if (!mediaElement) return;
    mediaElement.srcObject = null;
    mediaElement.pause();
    if (session.sessionDescriptionHandler instanceof SessionDescriptionHandlerWeb) {
        session.sessionDescriptionHandler.peerConnection.getSenders().forEach(s => s.track.stop())
    }
}
